if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-drawer");

        this.hideErrors = this.dataset.hideErrors === "true";
        // Fetch updated cart and update discount message on page load
        this.fetchUpdatedCart().then((cartQuantity) => {
          const countryData = this.getCountryFromUrl();
          this.updateDiscountMessage(countryData.country_code, cartQuantity);
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then(
            (res) => res.json()
          );

          $(document).trigger("product-form-responsed", [response]);

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
            });

          this.cartNotification.renderContents(response);

          this.initializeCarousel();
          const countryData = this.getCountryFromUrl();
          this.updateCustomLabels(countryData.country_code);

          const cartQuantity = await this.fetchUpdatedCart();
          this.updateDiscountMessage(countryData.country_code, cartQuantity);
        } catch (e) {
          console.error(e);
        } finally {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      initializeCarousel() {
        const $carousel = $(".upsell-carousel");
        if (!$carousel.hasClass("slick-initialized")) {
          $carousel.slick({
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            customPaging: function (slider, index) {
              return (
                '<button type="button" class="slick-dot">' +
                (index + 1) +
                "</button>"
              );
            },
            prevArrow:
              '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
            nextArrow:
              '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
          });
        }
      }

      async fetchUpdatedCart() {
        try {
          const response = await fetch("/cart.js");
          const cart = await response.json();
          const cartQuantity = cart.item_count;
          return cartQuantity;
        } catch (error) {
          console.error("Error fetching updated cart:", error);
          return 0; // Return 0 in case of an error
        }
      }

      updateCustomLabels(countryCode) {
        const secondaryCountries = [
          "AU",
          "US",
          "SG",
          "CA",
          "QA",
          "SA",
          "AE",
          "GB",
        ];

        const labels = document.querySelectorAll(".custom-label-eu");

        labels.forEach((label) => {
          if (countryCode === "EU" || countryCode === "DE") {
            label.innerHTML = "Total price, incl. VAT & Customs";
            label.style.display = "block";
          } else if (secondaryCountries.includes(countryCode)) {
            label.innerHTML = "Buy stress-free. We reimburse customs fee";
            label.style.display = "block";
          } else if (countryCode === "CH") {
            label.innerHTML = "Total price, incl. VAT";
            label.style.display = "block";
          } else {
            label.style.display = "none";
          }
        });
      }

      updateDiscountMessage(countryCode, cartQuantity) {
        if (!true) {
          return;
        }
        const discountTextTop = document.querySelector(
          ".discount-text-container"
        );

        if (discountTextTop) {
          discountTextTop.style.display = ["CH", "EU", "DE", "GB"].includes(
            countryCode
          )
            ? "block"
            : "none";
        }
      }

      getCountryFromUrl() {
        const url = window.location.href;

        if (url.includes("-eu")) {
          return { country_code: "EU", country_name: "Europe" };
        } else if (url.includes("-de/")) {
          return { country_code: "DE", country_name: "Germany" };
        } else if (url.includes("-in")) {
          return { country_code: "IN", country_name: "India" };
        } else if (url.includes("-us")) {
          return {
            country_code: "US",
            country_name: "United States of America",
          };
        } else if (url.includes("-uk")) {
          return { country_code: "GB", country_name: "United Kingdom" };
        } else if (url.includes("-au")) {
          return { country_code: "AU", country_name: "Australia" };
        } else if (url.includes("-sg")) {
          return { country_code: "SG", country_name: "Singapore" };
        } else if (url.includes("-ca")) {
          return { country_code: "CA", country_name: "Canada" };
        } else if (url.includes("-qa")) {
          return { country_code: "QA", country_name: "Qatar" };
        } else if (url.includes("-sa")) {
          return { country_code: "SA", country_name: "Saudi Arabia" };
        } else if (url.includes("-ae")) {
          return { country_code: "AE", country_name: "United Arab Emirates" };
        } else {
          return { country_code: "CH", country_name: "Switzerland" }; // Default country if no match
        }
      }
    }
  );
}
